import { invalidatePageReads } from '../../utils/pageReadScope.mjs'

const createState = () => ({
  generation: 0,
  menuList: [],
  buttonPermissionList: [],
  initialized: false,
  loading: false,
  error: '',
  userId: '',
})

export default {
  namespaced: true,
  state: createState,
  getters: {
    hasPermission: (state) => (perms) => Boolean(perms)
      && state.buttonPermissionList.includes(String(perms)),
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = Boolean(loading)
    },
    setAccess(state, payload = {}) {
      state.generation += 1
      invalidatePageReads()
      state.menuList = Array.isArray(payload.menuList) ? payload.menuList : []
      state.buttonPermissionList = Array.isArray(payload.buttonPermissionList)
        ? payload.buttonPermissionList
        : []
      state.userId = payload.userId || ''
      state.initialized = true
      state.loading = false
      state.error = ''
    },
    setError(state, error) {
      state.generation += 1
      invalidatePageReads()
      state.menuList = []
      state.buttonPermissionList = []
      state.initialized = false
      state.loading = false
      state.error = String(error || '')
    },
    reset(state) {
      const generation = state.generation + 1
      Object.assign(state, createState())
      state.generation = generation
      invalidatePageReads()
    },
  },
}
